import { IPartBomItemNote } from 'partBoms/types';
import { PartType } from 'parts/enums';

import { IUpsertItemFormData } from './types';

export const mapUpsertItemData = (
  data: IUpsertItemFormData,
  partBomItemId: number,
  partBomId: number
) => {
  const { part, manufacturer } = data;

  const isEdit = !!partBomItemId;

  let editInfo = {};
  if (isEdit) {
    editInfo = { id: partBomItemId };
  }

  let manufacturerId: number | string = manufacturer?.id || null;
  if (manufacturer?.isNew) {
    manufacturerId = `__tmp__${manufacturer?.name}`;
  }

  let unverifiedPartInfo: { description?: string; descriptionLong?: string } = {};
  if (!part?.verified && (!isEdit || part?.type !== PartType.BOM)) {
    unverifiedPartInfo = {
      description: data?.description || '',
      descriptionLong: data?.description,
    };
  }

  return {
    partBomItem: {
      ...editInfo,
      ...unverifiedPartInfo,
      parentPartId: partBomId,
      part: data.part.number,
      manufacturerId,
      description: unverifiedPartInfo.description || '',
      quantity: data.quantity,
      uom: data.uom,
      notes: mapUpsertItemNotes(data.notes),
    },
  };
};

const mapUpsertItemNotes = (notes: IPartBomItemNote[]) => {
  return notes?.map((note: IPartBomItemNote) => ({
    type: note.type,
    content: note.content,
  }));
};
